import { render, staticRenderFns } from "./FillColorSection.vue?vue&type=template&id=384989ca&scoped=true"
import script from "./FillColorSection.vue?vue&type=script&lang=js"
export * from "./FillColorSection.vue?vue&type=script&lang=js"
import style0 from "./FillColorSection.vue?vue&type=style&index=0&id=384989ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384989ca",
  null
  
)

export default component.exports